<template>
  <div class="filter-tag-list">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
@import "@styles/layout/breakpoint";
@import "@styles/themes/sls-theme/tokens/spacing";

.filter-tag-list {
  display: flex;
  padding: $spacing-03 0;
  overflow-x: auto;

  @include media("desktop") {
    flex-flow: row wrap;
    overflow-x: unset;
  }
}
</style>
